import {NgModule} from '@angular/core';
import {AsyncPipe} from "@angular/common";
import {SharedModule} from "../../shared/shared.module";
import {ChooseContactComponent} from "./components/choose-contact/choose-contact.component";
import { ContactManagementComponent } from './components/contact-management/contact-management.component';
import { NavigationManagementComponent } from './components/navigation-management/navigation-management.component';
import { CompetentAuthoritiesManagementComponent } from './components/competent-authorities-management/competent-authorities-management.component';
import { CompetentAuthorityCreateDialogComponent } from './components/competent-authority-create-dialog/competent-authority-create-dialog.component';
import { CompetentAuthorityEditDialogComponent } from './components/competent-authority-edit-dialog/competent-authority-edit-dialog.component';
import { MergeContactModalComponent } from './components/merge-contact-modal/merge-contact-modal.component';
import { ContactPersonDetailsComponent } from './components/contact-person-details/contact-person-details.component';
import {AnimalListTableComponent} from "./components/contact-person-details/animal-list-table.component";
import {AlphabetFilterComponent} from "../../shared/components/alphabet-filter/alphabet-filter.component";
import {RouterLink} from "@angular/router";
import { VeterinarianSelectComponent } from './components/veterinarian-select/veterinarian-select.component';

@NgModule({
  imports: [
    SharedModule,
    AsyncPipe,
    AnimalListTableComponent,
    AlphabetFilterComponent,
    RouterLink,
  ],
  declarations: [
    ChooseContactComponent,
    ContactManagementComponent,
    NavigationManagementComponent,
    CompetentAuthoritiesManagementComponent,
    CompetentAuthorityCreateDialogComponent,
    CompetentAuthorityEditDialogComponent,
    MergeContactModalComponent,
    ContactPersonDetailsComponent,
    VeterinarianSelectComponent
  ],
  exports: [
    ContactManagementComponent,
    ChooseContactComponent,
    NavigationManagementComponent,
    CompetentAuthoritiesManagementComponent,
    CompetentAuthorityCreateDialogComponent,
    VeterinarianSelectComponent
  ],
})
export class ContactsModule {
}
